// reach_ui/src/index.js
import React from 'react'
import { render } from 'react-dom'
import { AmplifyAuthenticator, AmplifySignUp } from '@aws-amplify/ui-react'
import Amplify, { Analytics } from 'aws-amplify'
import awsmobile from 'aws-exports'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import { configureStore, history } from 'store/configureStore'
import App from 'components/App'
import 'index.css'
import registerServiceWorker from 'registerServiceWorker'
import google_client_id from 'googleClientId'
import '@progress/kendo-theme-material/dist/all.css'
import { AuthState, onAuthUIStateChange } from '@aws-amplify/ui-components'
import { read } from './actions/data'
import { selectConversation, toggleThreadView } from './actions/inbox'
import { setPhoneState } from './actions/phone'
import { openLoadingDialog } from 'actions/view'
import CustomAuth from './components/CustomAuth'
import Snackbar from 'components/Snackbar'

Amplify.configure(awsmobile)
Analytics.disable()

const urlParams = new URLSearchParams(window.location.search)
const jwtToken = urlParams.get('jwtToken')
const showOldLoginScreen = urlParams.get('showOldLoginScreen')

const store = configureStore()

registerServiceWorker()

export const viewConversation = contactID => dispatch => {
  if (contactID) {
    dispatch(
      read(
        contactID?.match?.(/([0-9])\w+/g)?.[0],
        'inbox',
        'inbox/conversation',
        'contact_id',
      ),
    ).then(payload => {
      if (payload?.conversation?.length) {
        dispatch(openLoadingDialog(true))
        history.push('/inbox')
        setTimeout(() => {
          dispatch(selectConversation(contactID?.match?.(/([0-9])\w+/g)?.[0]))
          dispatch(openLoadingDialog(false))
        }, 1000)
      } else if (payload?.contact_id) {
        history.push(`/contacts/${payload.contact_id}`)
      }
      return payload
    })
  } else {
    dispatch(toggleThreadView(false))
    dispatch(selectConversation(null))
  }
}

export const dispatchFromWindow = jsonString => dispatch =>
  dispatch(JSON.parse(jsonString))

window.viewConversation = contactID =>
  store.dispatch(viewConversation(contactID))

window.dispatchFromWindow = jsonString =>
  store.dispatch(dispatchFromWindow(jsonString))

window.setPhoneState = payload => store.dispatch(setPhoneState(payload))

export const wrap = Component =>
  render(
    React.createElement(
      jwtToken
        ? () => (
            <Provider store={store}>
              <ConnectedRouter history={history}>
                <Component />
              </ConnectedRouter>
            </Provider>
          )
        : () => {
            const [authState, setAuthState] = React.useState()
            const [user, setUser] = React.useState()

            React.useEffect(() => {
              return onAuthUIStateChange((nextAuthState, authData) => {
                setAuthState(nextAuthState)
                setUser(authData)
              })
            }, [])

            return authState === AuthState.SignedIn && user ? (
              <Provider store={store}>
                <ConnectedRouter history={history}>
                  <Component />
                </ConnectedRouter>
              </Provider>
            ) : !showOldLoginScreen ? (
              <Provider store={store}>
                <ConnectedRouter history={history}>
                  <CustomAuth setAuthState={setAuthState} setUser={setUser} />
                  <Snackbar />
                </ConnectedRouter>
              </Provider>
            ) : (
              <AmplifyAuthenticator>
                <AmplifySignUp
                  slot="sign-up"
                  usernameAlias="username"
                  formFields={[
                    {
                      type: 'given_name',
                      label: 'First Name',
                      placeholder: 'Enter your first name',
                      required: true,
                    },
                    {
                      type: 'family_name',
                      label: 'Last Name',
                      placeholder: 'Enter your last name',
                      required: true,
                    },
                    {
                      type: 'username',
                      label: 'Create a username',
                      placeholder: 'Enter a username',
                      required: true,
                    },
                    {
                      type: 'email',
                      label: 'Email Address',
                      placeholder: 'Enter your email',
                      required: true,
                    },
                    {
                      type: 'password',
                      label: 'Create a password',
                      placeholder: 'Enter a password',
                      required: true,
                    },
                    {
                      type: 'phone_number',
                      label: 'Phone number',
                      placeholder: 'Enter your phone number',
                      required: true,
                    },
                  ]}
                />
              </AmplifyAuthenticator>
            )
          },
      { federated: { google_client_id } },
    ),
    document.getElementById('root'),
  )

wrap(App)

if (module.hot) {
  module.hot.accept('components/App', () => {
    const NextApp = require('components/App').default
    wrap(NextApp)
  })
}
